import MDIGITAL_CONFIGURATION from './MDIGITAL_CONFIGURATION';
import MDIGITAL_LOCALIZATION from './MDIGITAL_LOCALIZATION';
import MDIGITAL_ON_PREM from './MDIGITAL_ON_PREM';
import MDIGITAL_LOGGER from './MDIGITAL_LOGGER';
import KAMPYLE_UTILS from './KAMPYLE_UTILS';
import KAMPYLE_EVENT_DISPATCHER from './KAMPYLE_EVENT_DISPATCHER';
import KAMPYLE_FUNC from './KAMPYLE_FUNC';
import KAMPYLE_CONSTANT from './KAMPYLE_CONSTANT';
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';
import MDIGITAL_TRACKER from './MDIGITAL_TRACKER';
import KAMPYLE_DATA from './KAMPYLE_DATA';

var rateLimitCounterMap = {};
var eventMdDataKeyReplacementMap = {
    additional_data: 'additionalData',
    additionalInfo: function (val) {
        return typeof val === 'string' ? val : 'additionalData'
    },
    error_logs: 'errorLogs',
    source_function: 'sourceFunction',
    formId: 'destinationForm'
};
var eventDataKeyReplacementMap = {
    errorMessage: 'message',
    uuid: 'feedbackUuid'
};
var autoActions = [
    'nebula_form_preSubmitted',
    'nebula_form_submitted',
    'MDigital_Form_Next_Page',
];

var COMMON_FIELDS;
var allDigitalEvents = {};
/**
 * initialEvents- Basic events that mainly happens upon onsite initialization, before we receive external configuration
 * nonConfigurationDependentEvents- Static events: not dependent on any provision *or* provisioned events that receives those provisions upon onsite generation using placeholders mechanism
 * configurationDependentEvents- Dynamic events: Trigger of those events depends on external configuration (provisions in dataJson)
 *
 * When 25dc1_MPC8353_enableDynamicAnalyticsEvents is enabled:
 * initialEvents: gets filtered based on a pre-generated list configured using placeholder mechanism
 * nonConfigurationDependentEvents & configurationDependentEvents: both becomes dynamic since we filter those based on a list inside onsiteData.json
 * When 23dcr5_MPC7566_extractProvisionsToOnsiteData is enabled:
 * initialEvents & nonConfigurationDependentEvents: Both static events, unfiltered.
 * configurationDependentEvents: Dynamic list, triggered based on onsiteData.json provisions list
 **/
var initialEvents = {
    neb_eventDispatcherError: {
        eventId: 'nebula_eventDispatcherError',
        eventDataKeys: ['errorMessage', 'errorStack'],
        memoryDataKey: 'currentFormId',
        eventMdDataKeys: ['additionalInfo']
    },
    MDigital_warning: {
        eventId: 'MDigital_warning',
        eventDataKeys: ['message']
    },
    MDigital_couldNotFetchData: {
        eventId: 'MDigital_couldNotFetchData',
        memoryDataKey: 'currentFormId',
        eventMdDataKeys: ['errorData']
    },
    MDigital_noJsonModalShown: {
        eventId: 'mdigital_noDataMessageDisplayed',
        eventMdDataKeys: ['additionalInfo']
    },
    neb_afterHttpGetRequestOnError: {
        eventId: 'nebula_after_http_get_request_on_error',
        memoryDataKey: 'currentFormId',
        eventMdDataKeys: ['httpRequestData'],
    },
    neb_afterHttpGetRequestOnErrorStatusCode: {
        eventId: 'nebula_after_http_get_request_on_error_status_code',
        eventMdDataKeys: ['httpRequestData'],
    },
    neb_afterHttpGetRequestOnTimeout: {
        eventId: 'nebula_after_http_get_request_on_timeout',
        eventMdDataKeys: ['httpRequestData'],
    },
    neb_afterHttpGetRequest: {
        eventId: 'nebula_after_http_get_request',
        memoryDataKey: 'currentFormId',
        eventMdDataKeys: ['httpRequestData'],
    },
    MDigital_directGenericInjection: {
        eventId: 'mdigital_directGenericInjection',
    },
}
var nonConfigurationDependentEvents = {
    neb_pageView: {
        eventId: 'nebula_page_view',
        disableProvision: KAMPYLE_CONSTANT.PROVISIONS.DISABLE_ANALYTICS_NEW_PAGE_EVENTS
    },
    neb_inviteAccepted: {
        eventId: 'nebula_invite_accepted',
    },
    neb_inviteDeclined: {
        eventId: 'nebula_invite_declined',
    },
    neb_showInvitation: {
        eventId: 'nebula_invitation_show',
        memoryDataKey: 'invitationTriggeringData',
        ...({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":true}.isDecibelEnabled) && {
            formatDataFunc: appendDecibelData,
        }
    },
    neb_feedbackSubmitted: {
        eventId: 'nebula_form_submitted',
        ...({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":true}.isDecibelEnabled) && {
            formatDataFunc: appendDecibelData
        }
    },
    neb_feedbackPreSubmitted: {
        eventId: 'nebula_form_preSubmitted'
    },
    neb_feedbackPostSubmitted: {
        eventId: 'nebula_form_postSubmitted',
        ...({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":true}.isDecibelEnabled) && {
            formatDataFunc: appendDecibelData
        }
    },
    neb_formShown: {
        eventId: 'nebula_form_show',
        ...({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":true}.isDecibelEnabled) && {
            formatDataFunc: appendDecibelData
        }
    },
    neb_buttonClicked: {
        eventId: 'nebula_button_clicked',
    },
    neb_sdkShowForm: {
        eventId: 'nebula_code_trigger_form',
    },
    neb_routeToForm: {
        eventId: 'nebula_route_to_form',
        eventMdDataKeys: ['formId'],
    },
    neb_formClosed: {
        eventId: 'nebula_form_closed',
    },
    neb_popupBlocked: {
        eventId: 'nebula_popup_blocked',
    },
    neb_skipInvitation: {
        eventId: 'nebula_invitation_skipped',
    },
    neb_formPageShown: {
        eventId: 'nebula_form_page_displayed',
    },
    neb_captureInit: {
        eventId: 'nebula_capture_init',
    },
    neb_captureImageClicked: {
        eventId: 'nebula_capture_image_clicked',
    },
    MDigital_Capture_Cancelled: {
        eventId: 'nebula_cancel_capture_clicked',
    },
    neb_cancel_capture_clicked: {
        eventId: 'nebula_cancel_capture_clicked',
    },
    neb_sdkSurveyDisplayed: {
        eventId: 'nebula_code_survey_displayed',
    },
    neb_feedbackUUIDisNull: {
        eventId: 'nebula_feedbackUuidIsNull'
    },
    neb_submitFeedbackFailed: {
        eventId: 'nebula_submitFeedbackFailed',
        eventDataKeys: ['uuid', 'errorMessage', 'errorStack']
    },
    MDigital_couldNotLoadFormApplication: {
        eventId: 'MDigital_couldNotLoadFormApplication',
        memoryDataKey: 'currentFormId',
        eventMdDataKeys: ['errorData']
    },
    MDigital_Invalid_Origin: {
        eventId: 'MDigital_Invalid_Origin'
    },
    screenCaptureRetake: {
        eventId: KAMPYLE_CONSTANT.EVENTS.SCREEN_CAPTURE_RETAKE
    },
    screenCaptureDelete: {
        eventId: KAMPYLE_CONSTANT.EVENTS.SCREEN_CAPTURE_DELETE
    },
};
var configurationDependentEvents = {
    neb_sessionStart: {
        eventId: 'session_start',
        provision: KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ANALYTICS_SESSION_EVENTS
    },
    neb_load_form_preload_proximity: {
        eventId: 'nebula_load_form_preload_proximity',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents,
    },
    neb_button_displayed: {
        eventId: 'nebula_button_displayed',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents,
        eventMdDataKeys: ['position'],
    },
    neb_invitation_loaded: {
        eventId: 'nebula_invitation_loaded',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents,
    },
    neb_invitation_ready: {
        eventId: 'nebula_invitation_ready',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents,
    },
    neb_form_loaded: {
        eventId: 'nebula_form_loaded',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents,
    },
    neb_formReady: {
        eventId: 'nebula_form_ready',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents,
    },
    MDigital_updatingSbtServer: {
        eventId: 'MDigital_updating_sbt_server',
        eventMdDataKeys: ['dataObjForSbt'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_settingIdentifierValueOnMemory: {
        eventId: 'MDigital_setting_identifier_value_on_memory',
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_shouldNotSyncIdentifier: {
        eventId: 'MDigital_should_not_sync_identifier',
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_beforeHttpPostRequest: {
        eventId: 'nebula_before_http_post_request',
        eventMdDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequestOnError: {
        eventId: 'nebula_after_http_post_request_on_error',
        eventMdDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequest: {
        eventId: 'nebula_after_http_post_request',
        eventMdDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequestOnErrorStatusCode: {
        eventId: 'nebula_after_http_post_request_on_error_status_code',
        eventMdDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequestOnTimeout: {
        eventId: 'nebula_after_http_post_request_on_timeout',
        eventMdDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_updateTargetingWithDeclinedDateInviteDeclined: {
        eventId: 'MDigital_update_targeting_with_declined_date_invite_declined',
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_updateTargetingWithSubmittedDate: {
        eventId: 'MDigital_update_targeting_with_submitted_date',
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_updateTargetingWithDeclinedDateFormClosed: {
        eventId: 'MDigital_update_targeting_with_declined_date_form_closed',
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_initUserIdentifier: {
        eventId: 'nebula_init_user_identifier',
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_initUserIdentifierOnExtraData: {
        eventId: 'nebula_init_user_identifier_on_extra_data',
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_Form_Next_Page: {
        eventId: 'MDigital_Form_Next_Page',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents
    },
    MDigital_Form_Back_Page: {
        eventId: 'MDigital_Form_Back_Page',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents
    },
    MDigital_Form_Close_No_Submit: {
        eventId: 'MDigital_Form_Close_No_Submit',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents
    },
    MDigital_ThankYou_Displayed: {
        eventId: 'MDigital_ThankYou_Displayed',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents
    },
    MDigital_ThankYou_Close: {
        eventId: 'MDigital_ThankYou_Close',
        provision: KAMPYLE_CONSTANT.PROVISIONS.analyticsNewEvents
    },
    MDigital_pageTargetingPhaseEnded: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_PAGE_TARGETING_PHASE_ENDED,
        provision: KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING,
        formatDataFunc: formatPageTargetingData,
        eventMdDataKeys: ['additionalData'],
        rateLimit: 1,
    },
    MDigital_behavioralTargetingPhaseEnded: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_BEHAVIORAL_TARGETING_PHASE_ENDED,
        provision: KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING,
        formatDataFunc: formatBehavioralTargetingData,
        eventMdDataKeys: ['additionalData'],
        rateLimit: 1,
    },
    MDigital_quarantinedSurveyPhaseEnded: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_QUARANTINED_SURVEY_PHASE_ENDED,
        provision: KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING,
        formatDataFunc: formatQuarantineTargetingData,
        eventMdDataKeys: ['additionalData'],
        rateLimit: 1,
    },
    MDigital_DynamicOnsiteInitializedSuccessfully: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_DYNAMIC_ONSITE_INITIALIZED_SUCCESSFULLY,
        provision: KAMPYLE_CONSTANT.PROVISIONS.DYNAMIC_ONSITE_EVENTS,
    },
    MDigital_createSession: {
        eventId: KAMPYLE_CONSTANT.EVENTS.CREATE_SESSION,
        provision: KAMPYLE_CONSTANT.PROVISIONS.CREATE_SESSION,
        eventMdDataKeys: ['additionalData']
    },
    mdigital_customEventsDebugMessage: {
        eventId: KAMPYLE_CONSTANT.EVENTS.CUSTOM_EVENTS_DEBUG_MESSAGE,
        eventDataKeys: ['customEventId', 'customEventData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.ENABLE_EVENTS_FOR_CE_DEBUG
    },
    MDigital_CHTML_Logs: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_CHTML_LOGS,
        provision: KAMPYLE_CONSTANT.PROVISIONS.CHTML_LOGS,
        eventMdDataKeys: ['source_function', 'additional_data', 'error_logs']
    },
};

function appendDecibelData(payload) {
    var formData = KAMPYLE_DATA.getFormData(payload.formId);
    var decibelBehavioural = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.decibelBehavioural');
    var decibelScore = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.decibelScore');

    if (decibelBehavioural) {
        KAMPYLE_UTILS.setNestedPropertyValue(payload, 'decibelBehavioural', decibelBehavioural.eventName);
    }

    if (decibelScore) {
        var decibelData = KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DECIBEL_DATA);
        KAMPYLE_UTILS.setNestedPropertyValue(payload, 'decibelScore', {
            eventName: decibelScore.eventName,
            score: decibelData[decibelScore.eventName]
        });
    }
    return payload;
}

function initRateLimiting(specificEvents) {
    var events = specificEvents || allDigitalEvents;
    Object.keys(events).forEach(function (ev) {
        var eventObj = events[ev];
        if (isEventDefinedAsRateLimited(eventObj)) {
            rateLimitCounterMap[eventObj.eventId] = 0;
        }
    });
}

function getOnsiteDataModificationDate() {
    var onsiteData = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
    return (onsiteData && onsiteData.modificationDate) || null;
}

function buildDataVersions(formId) {
    var result = {};
    var modificationDate = getOnsiteDataModificationDate();
    var formDataFileName = getFormDataFileName(formId);
    var invitationDataFileName = getInvitationDataFileName(formId);
    if (modificationDate) {
        result.onsiteDataModificationDate = modificationDate;
    }
    if (formDataFileName) {
        result.formDataFileName = formDataFileName;
    }
    if (invitationDataFileName) {
        result.invitationDataFileName = invitationDataFileName;
    }
    return result;
}

function extractFileNameFromUrl(url) {
    if (!url) {
        return null;
    }
    var fileName = url.substring(url.lastIndexOf('/') + 1);
    return fileName.replace('_###LANGUAGE_CODE###', '');
}

function getFormDataFileName(formId) {
    if (!formId) {
        return null;
    }
    var formData = KAMPYLE_DATA.getFormData(formId);
    return formData ? extractFileNameFromUrl(formData.formDataUrl) : null;
}

function getInvitationDataFileName(formId) {
    if (!formId) {
        return null;
    }
    var formData = KAMPYLE_DATA.getFormData(formId);
    var inviteDataUrl = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'inviteData.inviteDataUrl');
    return extractFileNameFromUrl(inviteDataUrl);
}

// formHtmlUrl looks like `.../md-form/<propertyType>/<version>/index.html`
// or `index_csp.html` when CSP is enabled - both share the same version.
function getFormVersionFromUrl(formId) {
    if (!formId) {
        return null;
    }
    var formData = KAMPYLE_DATA.getFormData(formId);
    if (!formData || !formData.formHtmlUrl) {
        return null;
    }
    var path = formData.formHtmlUrl.split('?')[0];
    var match = path.match(/\/([^/]+)\/index(?:_csp)?\.html$/);
    return match ? match[1] : null;
}

function getDataToSend(dataFormatted) {
    var feedbackUUID = dataFormatted.feedbackUUID;

    if (!dataFormatted.accountId) {
        KAMPYLE_EVENT_DISPATCHER.appendDefaultEventParams(dataFormatted);
    }
    const isTargetingEventsReporting = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING);

    var dataToSend = {
        accountId: dataFormatted.accountId,
        propertyId: dataFormatted.websiteId,
        feedbackUuid: feedbackUUID,
        formId: dataFormatted.formId || null,
        formTriggerType: KAMPYLE_DATA.getFormTriggerType(dataFormatted.formId),
        mdData: dataFormatted.mdData || {},
        userId: dataFormatted.userId || null,
        sessionId: dataFormatted.sessionId || null,
        cookieSize: dataFormatted.cookieSize || null,
        sdkVersion: window.MDIGITAL.version || '0.0.0.0',
        historyLength: window.history.length,
        isUserIdentified: !!KAMPYLE_DATA.getMemoryData('identifierValue'),
        feedbackCorrelationUuid: dataFormatted.feedbackCorrelationUUID,
        clientEventUuid: KAMPYLE_UTILS.kampyleCreateUUID(),
        deviceType: KAMPYLE_FUNC.checkDevice(),
    };

    var formVersion = getFormVersionFromUrl(dataFormatted.formId);
    if (formVersion) {
        dataToSend.formVersion = formVersion;
    }
    var dataVersions = buildDataVersions(dataFormatted.formId);
    if (Object.keys(dataVersions).length > 0) {
        dataToSend.dataVersions = dataVersions;
    }

    if ({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":true}.isDecibelEnabled) {
        if (dataFormatted.decibelBehavioural) {
            Object.assign(dataToSend.mdData, {
                decibelBehavioural: dataFormatted.decibelBehavioural
            });
        }
        if (dataFormatted.decibelScore) {
            Object.assign(dataToSend.mdData, {
                decibelScore: dataFormatted.decibelScore
            });
        }
    }

    if (dataFormatted.formId) {
        dataToSend.webFormLang = MDIGITAL_LOCALIZATION.getFormLanguage(dataFormatted.formId) || null;
    }
    if ({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":true}.isOnPremEnabled) {
        dataToSend.packageVersion = MDIGITAL_ON_PREM.getPackageVersion();
    }

    addEventDataKeys(dataFormatted, dataToSend);

    if (isTargetingEventsReporting && dataFormatted.mdTargetingData) {
        dataToSend.mdData.mdTargetingData = dataFormatted.mdTargetingData;
    }

    return dataToSend;
}

function addEventDataKeys(dataFormatted, dataToSend) {
    var digitalEvent = allDigitalEvents[dataFormatted.eventName];
    var eventDataKeys = digitalEvent ? digitalEvent.eventDataKeys : null;
    if (eventDataKeys) {
        for (var i = 0; i < eventDataKeys.length; i++) {
            var eventDataKeyName = eventDataKeyReplacementMap[eventDataKeys[i]] || eventDataKeys[i];
            dataToSend[eventDataKeyName] = dataFormatted[eventDataKeys[i]] || null;
        }
    }
}

function sendDigitalAnalytics(dataFormatted) {
    if (!dataFormatted || !window.MDIGITAL.md_tracker) {
        return false;
    }
    var dataToSend = getDataToSend(dataFormatted);
    MDIGITAL_ANALYTICS.makeAnalyticsCalls(dataFormatted.eventId, dataToSend);
    return true;
}

function formatData(eventName, oData) {
    if (!eventName || !oData) {
        return null;
    }

    var result = Object.assign({}, oData);

    //fill with defaults
    for (var prop in COMMON_FIELDS) {
        result[prop] = COMMON_FIELDS[prop];
    }

    //Fill with event specific variables
    for (var eventProp in allDigitalEvents[eventName]) {
        result[eventProp] = allDigitalEvents[eventName][eventProp];
    }

    var digitalData = KAMPYLE_UTILS.getAllKampyleData();
    result.mdData = {
        submittedDate: digitalData.SUBMITTED_DATE,
        declinedDate: digitalData.DECLINED_DATE,
        lastInvitationView: digitalData.LAST_INVITATION_VIEW,
        mdUserPercentile: digitalData.kampyleUserPercentile,
        mdInvitePresented: digitalData.kampyleInvitePresented,
    }

    appendMemoryDataByEventName(eventName, result);
    appendMdDataByEventName(eventName, result.mdData, result);

    result.sessionId = digitalData.kampyleUserSession;
    result.cookieSize = KAMPYLE_UTILS.getByteSize(document.cookie);
    result.pageURL = location.href;
    if (autoActions.includes(result.eventId) && oData.isAutoAction) {
        result.eventId = result.eventId + '_Auto';
    }
    result.eventName = eventName;
    return result;
}

var triggerDigitalEvent = function (eventName, oData) {
    var eventObj = allDigitalEvents[eventName];
    if (!(eventObj && isEventProvisioned(eventObj)) || isRateLimitExceeded(eventObj)) {
        return false;
    }

    var shouldFormatEventData = eventObj.formatDataFunc && typeof eventObj.formatDataFunc === 'function';
    if (shouldFormatEventData) {
        oData = eventObj.formatDataFunc.call(this, oData);
    }

    var oDataFormatted = formatData(eventName, oData);

    MDIGITAL_ANALYTICS.sendDigitalAnalytics(oDataFormatted);
}

function isEventProvisioned(eventObj) {
    var isDisabled = eventObj.disableProvision && KAMPYLE_FUNC.checkProvision(eventObj.disableProvision);
    return !isDisabled && (!eventObj.provision || !!KAMPYLE_FUNC.checkProvision(eventObj.provision)); // Support backwards compatibility
}

function isEventDefinedAsRateLimited(eventObj) {
    return typeof eventObj.rateLimit === 'number' && eventObj.rateLimit > 0;
}

function getEventCallsCounter(eventId) {
    var counter = rateLimitCounterMap[eventId];
    return typeof counter === 'number' ? counter : null;
}

function isRateLimitExceeded(eventObj) {
    var counter = getEventCallsCounter(eventObj.eventId);
    return KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ANALYTICS_EVNETS_LIMIT) && typeof counter === 'number' && counter >= eventObj.rateLimit;
}

function increaseEventCallsCounter(eventId) {
    if (getEventCallsCounter(eventId) === null) {
        return null;
    }
    return ++(rateLimitCounterMap[eventId]);
}

function triggerDigitalAnalyticsEventDispatcherError(eventData) {
    if (!eventData || !window.MDIGITAL.md_tracker) {
        return false;
    }
    var dataFormatted = formatData('neb_eventDispatcherError', eventData);
    var dataToSend = getDataToSend(dataFormatted);
    MDIGITAL_ANALYTICS.makeAnalyticsCalls(dataFormatted.eventId, dataToSend);
    return dataToSend;
}

function makeAnalyticsCalls(eventId, dataToSend) {
    try {
        window.MDIGITAL.md_tracker.trackEvent(eventId, dataToSend);
        getEventCallsCounter(eventId) !== null && increaseEventCallsCounter(eventId);
    } catch (e) {
        console.warn(e);
    }
}

function initTracker() {
    try {
        COMMON_FIELDS = {
            userId: KAMPYLE_UTILS.kampyleGetUserId(),
        };

        try {
            /** This will register basic functions that used to send events to the server,
             * so we can now call window.MDIGITAL.md_tracker.trackEvent. The events will be sent only after the full tracker will be loaded!
             * We must call init in order to register the basic functions (trackEvent, trackEventLater, set_config...)
             */
            MDIGITAL_TRACKER.loadBaseTracker();
            var tracker_config = {
                api_host: KAMPYLE_CONSTANT.PLACEHOLDERS.DEFAULT_ANALYTICS_SUBMIT_EVENTS_URL,
                topic: KAMPYLE_CONSTANT.PLACEHOLDERS.DEFAULT_MEC_INTEGRATION_ID
            };
            window.MDIGITAL.md_tracker.init(tracker_config);
            /** This will take the collected events and send them to api_host, with the header Md-Integration-Id (topic)
             *  and will send POST xhr for every event called by trackEvent immediately. It adds some extra info:
             *  sessionScreenSize, sessionDua, sessionPlatform, referringUrl, pageTitle, pageUrl, type, timestamp, eventTimezoneOffset
             */
            MDIGITAL_TRACKER.loadFullTracker();

            if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ANALYTICS_EVNETS_LIMIT)) {
                initRateLimiting(initialEvents);
                initRateLimiting(nonConfigurationDependentEvents);
                KAMPYLE_EVENT_DISPATCHER.subscribeOnce(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_SDK_PAGE_VIEW, initRateLimiting);
            }
        } catch (e) {
            console.warn(e);
        }
        
        if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_DYNAMIC_ANALYTICS_EVENTS)) {
            var configEventsList = JSON.parse(KAMPYLE_CONSTANT.PLACEHOLDERS.DIGITAL_ANALYTICS_STATIC_EVENTS_LIST || '[]');
            initialEvents = filterEventsByConfig(initialEvents, configEventsList);
        } else {
            Object.assign(allDigitalEvents, nonConfigurationDependentEvents);
            KAMPYLE_UTILS.initEventSubscriptions(nonConfigurationDependentEvents, triggerDigitalEvent);
        }
        Object.assign(allDigitalEvents, initialEvents);
        KAMPYLE_UTILS.initEventSubscriptions(initialEvents, triggerDigitalEvent);
        return true;
    } catch (e) {
        console.warn(e);
    }
}

function filterEventsByConfig(allEventsList, configEventsList) {
    var filteredEventsByConfig = {};
    for (var eventKey in allEventsList) {
        if (configEventsList && configEventsList.includes(allEventsList[eventKey].eventId)) {
            filteredEventsByConfig[eventKey] = allEventsList[eventKey];
        }
    }
    return filteredEventsByConfig;
}

function updateTrackerAnalyticsUrl() {
    var onsiteData = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
    if (onsiteData && onsiteData.analyticsSubmitEventsUrl) {
        var tracker_config = {
            api_host: onsiteData.analyticsSubmitEventsUrl,
            topic: onsiteData.mecIntegrationId
        };
        window.MDIGITAL.md_tracker.set_config(tracker_config);
    } else {
        console.error(new Error('No Digital analytics url was found!'))
    }

}

function registerConfigurationDependentEvents() {
    var dynamicEvents = {};
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_DYNAMIC_ANALYTICS_EVENTS)) {
        var onsiteData = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
        var configEventsList = onsiteData.digitalAnalyticsDynamicEventsList;
        Object.assign(dynamicEvents, configurationDependentEvents, nonConfigurationDependentEvents);
        dynamicEvents = filterEventsByConfig(dynamicEvents, configEventsList);
    } else {
        Object.assign(dynamicEvents, configurationDependentEvents);
    }
    Object.assign(allDigitalEvents, dynamicEvents);
    initRateLimiting(dynamicEvents);
    KAMPYLE_UTILS.initEventSubscriptions(dynamicEvents, triggerDigitalEvent);
}

function appendMemoryDataByEventName(eventName, eventJsonData) {
    eventJsonData = eventJsonData || {};
    var memoryDataKey = allDigitalEvents[eventName].memoryDataKey;
    var memoryData = KAMPYLE_DATA.getMemoryData(memoryDataKey);
    if (memoryData && memoryDataKey === 'currentFormId') {
      eventJsonData.formId = memoryData;
    }
    else if (memoryData) {
        eventJsonData.mdData = eventJsonData.mdData || {};
        eventJsonData.mdData[memoryDataKey] = memoryData;
    }
    return eventJsonData;
}

function appendMdDataByEventName(eventName, mdDataObj, eventJsonData) {
    eventJsonData = eventJsonData || {};
    var eventMdDataKeys = allDigitalEvents[eventName].eventMdDataKeys;
    if (eventMdDataKeys) {
        for (var i = 0; i < eventMdDataKeys.length; i++) {
            var eventMdDataKey = eventMdDataKeys[i];
            var eventData = eventJsonData[eventMdDataKey];
            var eventMdDataKeyName = eventMdDataKeyReplacementMap[eventMdDataKey] || eventMdDataKey;
            if (typeof eventMdDataKeyName === 'function') {
                eventMdDataKeyName = eventMdDataKeyName(eventData);
            }
            mdDataObj[eventMdDataKeyName] = eventData;
        }
    }
    return mdDataObj;
}

function getFinalConditionResult(accumulator, current) {
    return accumulator && current.isPassed;
}

function getFormTargetingData(form, targetingPhase) {
    form = form || {};
    var formState = KAMPYLE_DATA.getFormState(form.formId);
    if (!formState || !formState.targeting) {

        MDIGITAL_LOGGER.error("Digital Analytics - getFormTargetingData: failed to build " + targetingPhase + " phase data for form id: " + form.id);

        return false;
    }

    var conditions = formState.targeting[targetingPhase];
    var dataToSend = {
        formId: form.formId,
        formType: form.formType,
        evaluationResult: conditions === null ? false : (conditions || []).reduce(getFinalConditionResult, true),
        conditions: conditions
    };

    return dataToSend;
}

function formatPageTargetingData() {
    var dataToSend = [];
    var allForms = KAMPYLE_DATA.getAllForms() || [];
    allForms.forEach(function (form) {
        dataToSend.push(getFormTargetingData(form, KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING));
    });
    return {mdTargetingData: dataToSend};
}

function formatBehavioralTargetingData(formData) {
    return {mdTargetingData: getFormTargetingData(formData, KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING)};
}

function formatQuarantineTargetingData(formData) {
    var form = getFormTargetingData(formData, KAMPYLE_CONSTANT.TARGETING_PHASES.QUARANTINE_TARGETING) || {};
    form.userIdentifierValue = KAMPYLE_DATA.getMemoryData('identifierValue');
    return {mdTargetingData: form};
}

export default {
    //for testing
    getDataToSend: getDataToSend,
    getOnsiteDataModificationDate: getOnsiteDataModificationDate,
    extractFileNameFromUrl: extractFileNameFromUrl,
    getFormDataFileName: getFormDataFileName,
    getInvitationDataFileName: getInvitationDataFileName,
    getFormVersionFromUrl: getFormVersionFromUrl,
    buildDataVersions: buildDataVersions,
    sendDigitalAnalytics: sendDigitalAnalytics,
    formatData: formatData,
    appendDataByEventName: appendMdDataByEventName,
    appendMemoryDataByEventName: appendMemoryDataByEventName,
    addEventDataKeys: addEventDataKeys,
    makeAnalyticsCalls: makeAnalyticsCalls,
    rateLimitCounterMap: rateLimitCounterMap,

    isEventProvisioned: isEventProvisioned,
    isEventDefinedAsRateLimited: isEventDefinedAsRateLimited,
    getEventCallsCounter: getEventCallsCounter,
    isRateLimitExceeded: isRateLimitExceeded,
    increaseEventCallsCounter: increaseEventCallsCounter,
    initRateLimiting: initRateLimiting,

    initTracker: initTracker,
    updateTrackerAnalyticsUrl: updateTrackerAnalyticsUrl,
    registerConfigurationDependentEvents: registerConfigurationDependentEvents,
    triggerDigitalEvent: triggerDigitalEvent,
    triggerDigitalAnalyticsEventDispatcherError: triggerDigitalAnalyticsEventDispatcherError,
    formatPageTargetingData: formatPageTargetingData,
    formatBehavioralTargetingData: formatBehavioralTargetingData,
    formatQuarantineTargetingData: formatQuarantineTargetingData,
    getFormTargetingData: getFormTargetingData
};
